import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  uploadIcon: {

  },
  details: {
    fontSize: "14px",
    fontWeight: "600",
    color: colors.lightBlack,
    margin: "20px 0px 0px"
  },
  optionDetails: {
    fontSize: "14px",
    margin: "8px 0px",
    display: "flex",
    "& span": {
      height: "fit-content"
    }
  },
  element: {
    fontSize: "12px",
    fontWeight: "500",
    color: theme.tooltip.styleOne.color,
    backgroundColor: theme.tooltip.styleOne.backgroundColor,
    borderRadius: "16px",
    padding: "2px 8px",
    marginRight: "4px",
  },
  button: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    fontSize: "16px"
  },
  buttonsWrapper: {
    marginTop: "32px",
    display: "flex"
  },
  colCancel:{
    padding:"0px",
    marginRight:"6px",
    marginLeft:"12px"
  },
  colSubmit:{
    padding:"0px",
    marginLeft:"6px",
    marginRight:"12px"
  },
}))

export default styles;
